export enum NotificationTypes {

    GET_NOTIFICATION_LIST_LOADING = "@@notification/GET_NOTIFICATION_LIST_LOADING",
    GET_NOTIFICATION_LIST_SUCCESS = "@@notification/GET_NOTIFICATION_LIST_SUCCESS",
    GET_NOTIFICATION_LIST_ERROR = "@@notification/GET_NOTIFICATION_LIST_ERROR",

    GET_BY_ID_NOTIFICATION_LOADING = "@@notification/GET_BY_ID_NOTIFICATION_LOADING",
    GET_BY_ID_NOTIFICATION_SUCCESS = "@@notification/GET_BY_ID_NOTIFICATION_SUCCESS",
    GET_BY_ID_NOTIFICATION_ERROR = "@@notification/GET_BY_ID_NOTIFICATION_ERROR",

    GET_NOTIFICATION_CONFIG_LOADING = "@@notification/GET_NOTIFICATION_CONFIG_LOADING",
    GET_NOTIFICATION_CONFIG_SUCCESS = "@@notification/GET_NOTIFICATION_CONFIG_SUCCESS",
    GET_NOTIFICATION_CONFIG_ERROR = "@@notification/GET_NOTIFICATION_CONFIG_ERROR",

    POST_NOTIFICATION_CONFIG_LOADING = "@@notification/POST_NOTIFICATION_CONFIG_LOADING",
    POST_NOTIFICATION_CONFIG_SUCCESS = "@@notification/POST_NOTIFICATION_CONFIG_SUCCESS",
    POST_NOTIFICATION_CONFIG_ERROR = "@@notification/POST_NOTIFICATION_CONFIG_ERROR",

    GET_NOTIFICATION_STATUS_LOADING = "@@notification/GET_NOTIFICATION_STATUS_LOADING",
    GET_NOTIFICATION_STATUS_SUCCESS = "@@notification/GET_NOTIFICATION_STATUS_SUCCESS",
    GET_NOTIFICATION_STATUS_ERROR = "@@notification/GET_NOTIFICATION_STATUS_ERROR",

    GET_NOTIFICATION_LOADING = "@@notification/GET_NOTIFICATION_LOADING",
    GET_NOTIFICATION_SUCCESS = "@@notification/GET_NOTIFICATION_SUCCESS",
    GET_NOTIFICATION_ERROR = "@@notification/GET_NOTIFICATION_ERROR",

    GET_NOTIFICATION_COUNT_LOADING = "@@notification/GET_NOTIFICATION_COUNT_LOADING",
    GET_NOTIFICATION_COUNT_SUCCESS = "@@notification/GET_NOTIFICATION_COUNT_SUCCESS",
    GET_NOTIFICATION_COUNT_ERROR = "@@notification/GET_NOTIFICATION_COUNT_ERROR",

    CLOSE_NOTIFICATION_LOADING = "@@notification/CLOSE_NOTIFICATION_LOADING",
    CLOSE_NOTIFICATION_SUCCESS = "@@notification/CLOSE_NOTIFICATION_SUCCESS",
    CLOSE_NOTIFICATION_ERROR = "@@notification/CLOSE_NOTIFICATION_ERROR",

    CLOSE_ALL_NOTIFICATION_LOADING = "@@notification/CLOSE_ALL_NOTIFICATION_LOADING",
    CLOSE_ALL_NOTIFICATION_SUCCESS = "@@notification/CLOSE_ALL_NOTIFICATION_SUCCESS",
    CLOSE_ALL_NOTIFICATION_ERROR = "@@notification/CLOSE_ALL_NOTIFICATION_ERROR",

    CLEAR_NOTIFICATION_MESSAGE = "@@notification/CLEAR_NOTIFICATION_MESSAGE",

    CLEAR_NOTIFICATION_CONFIG = "@@notification/CLEAR_NOTIFICATION_CONFIG",
}